import * as types from '../constants';

export const defaultFilterState = {
   isOpen: false,
};

export const globalFilter = (state = defaultFilterState, action) => {
   switch (action.type) {
      case types.GLOBAL_FILTER_SET_OPEN:
         return {
            ...state,
            isOpen: true,
         };
      case types.GLOBAL_FILTER_SET_CLOSE:
         return {
            ...state,
            isOpen: false,
         };
      default:
         return state;
   }
};
